module.exports = __webpack_public_path__ + "img/rectangulo-r.97645045.svg";